import React, { useState } from 'react'
import { TextField, RenderCurrencyFormatTextField, Button } from '@components/atoms'
import { Modal, FormControlLabel, Switch, Box, IconButton } from '@mui/material'

import { useDispatch } from 'react-redux'
import { productActions } from '@redux/store/index'
import CloseIcon from '@mui/icons-material/Close'
import { mono, boFont } from '@components/systems/backoffice/backoffice.tokens'

interface ProductRegistrationModalProps {
	open: boolean
	onClose: () => void
}

/** 제품 등록 — 수정 모달과 같은 문법 */
export const ProductRegistrationModal: React.FC<ProductRegistrationModalProps> = ({
	open,
	onClose,
}) => {
	const dispatch = useDispatch()
	const [name, setName] = useState('')
	const [code, setCode] = useState('')
	const [usd, setUsd] = useState<number>(0)
	const [index, setIndex] = useState('')
	const [useYn, setUseYn] = useState(true)
	const [errors, setErrors] = useState<{ [key: string]: string }>({})

	const validateForm = () => {
		const newErrors: { [key: string]: string } = {}
		if (!name.trim()) newErrors.name = '제품명을 입력해주세요.'
		if (usd === 0) newErrors.usd = '가격을 입력해주세요.'
		if (isNaN(Number(usd))) newErrors.usd = '유효한 가격을 입력해주세요.'
		if (!index.trim()) newErrors.index = '인덱스를 입력해주세요.'
		setErrors(newErrors)
		return Object.keys(newErrors).length === 0
	}

	const handleRegister = () => {
		if (validateForm()) {
			dispatch(productActions.REGISTER_PRODUCT({ name, code, usd, index, useYn }))
			handleClose()
		}
	}

	const handleClose = () => {
		setName('')
		setCode('')
		setUsd(0)
		setIndex('')
		setUseYn(true)
		setErrors({})
		onClose()
	}

	return (
		<Modal open={open} onClose={handleClose}>
			<Box component="div" sx={styles.modalContent}>
				<Box component="div" sx={styles.head}>
					<Box component="span" sx={styles.kicker}>
						Product
					</Box>
					<IconButton onClick={handleClose} size="small" aria-label="close">
						<CloseIcon fontSize="small" />
					</IconButton>
				</Box>
				<Box component="h2" sx={styles.title}>
					제품 등록
				</Box>
				<TextField
					label="제품명"
					variant="standard"
					value={name}
					onChange={e => setName(e.target.value)}
					fullWidth
					margin="normal"
					error={!!errors.name}
					helperText={errors.name}
				/>
				<TextField
					label="제품코드"
					variant="standard"
					value={code}
					onChange={e => setCode(e.target.value)}
					fullWidth
					margin="normal"
					error={!!errors.name}
					helperText={errors.name}
				/>
				<TextField
					label="가격 (USD)"
					variant="standard"
					value={usd}
					onChange={e => setUsd(Number(e.target.value))}
					fullWidth
					margin="normal"
					error={!!errors.usd}
					helperText={errors.usd}
					InputProps={{
						inputComponent: RenderCurrencyFormatTextField,
					}}
				/>
				<TextField
					label="인덱스"
					variant="standard"
					value={index}
					onChange={e => setIndex(e.target.value)}
					fullWidth
					margin="normal"
					error={!!errors.index}
					helperText={errors.index}
				/>
				<FormControlLabel
					control={<Switch checked={useYn} onChange={e => setUseYn(e.target.checked)} />}
					label="사용 여부"
					sx={styles.switch}
				/>
				<Button onClick={handleRegister} variant="contained" fullWidth sx={styles.button}>
					등록
				</Button>
			</Box>
		</Modal>
	)
}

const styles = {
	modalContent: {
		position: 'absolute',
		top: '50%',
		left: '50%',
		transform: 'translate(-50%, -50%)',
		width: 420,
		maxWidth: 'calc(100vw - 32px)',
		backgroundColor: mono.surface,
		border: `1px solid ${mono.line}`,
		boxShadow: '0 30px 60px rgba(20, 24, 32, 0.12)',
		padding: '24px 28px 28px',
		borderRadius: 0,
		textAlign: 'left',
		fontFamily: boFont.ui,
		outline: 'none',
	},
	head: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'space-between',
	},
	kicker: {
		fontSize: 11,
		letterSpacing: '.24em',
		textTransform: 'uppercase',
		color: mono.faint,
		fontWeight: 500,
	},
	title: {
		margin: '8px 0 12px',
		fontSize: 24,
		fontWeight: 300,
		lineHeight: 1.15,
		color: mono.ink,
	},
	switch: {
		marginTop: 2,
		marginBottom: 3,
		'.MuiFormControlLabel-label': { fontSize: 13, color: mono.dim },
	},
	button: {
		marginTop: 2,
	},
}
